// extracted by mini-css-extract-plugin
export default {"link":"WwQZTk_AMaKQD_fMzcwG","placeHolderShimmer":"yDqD08Kzz_ImhQhJ4Inp"};